var map = {
	"./test.jpg": "724e",
	"./张岩峰.jpg": "14af",
	"./张顺哲.jpg": "f3bf",
	"./截图样例.jpg": "67eb",
	"./祝礼祥.jpg": "4a47",
	"./秦伟卿.jpg": "60cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";